export default __webpack_public_path__ + "static/media/cp1.f16e2433.svg";